import type { CatalogListType } from 'context/catalogs/types';
import { createOption } from 'utils/form';

export const catalogKeys = [
  'CAT_CASA_BOLSA',
  'CAT_PERFILES',
  'CAT_BANQUEROS',
  'CAT_NACIONALIDAD',
  'CAT_EDO_CIVIL',
  'CAT_ORIGEN_RECURSOS',
  'CAT_PROPOSITO_RECURSO',
  'CAT_PROFESION',
  'CAT_OCUPACION',
  'CAT_PUESTO',
  'CAT_ENTIDAD',
  'CAT_GIRO',
  'CAT_SECTOR',
  'CAT_ACTIVIDAD_ECONOMICA',
  'CAT_ACTIVIDAD_ECONOMICA_RIESGO',
  'CAT_PERIODICIDAD',
  'CAT_MONEDA',
  'CAT_PARENTESCO',
  'CAT_BANCOS',
  'CAT_GENERO',
  'CAT_TIPO_CASA',
  'CAT_ACTIVIDADES_EMPRESA',
  'CAT_PERFILES_MORAL',
  'CAT_OCUPACION_PERFILAMIENTO',
  'CAT_FRECUENCIA_PERFILAMIENTO',
  'CAT_CONOCIMIENTOS_INVERSION',
  'CAT_PLAZOS_PERFILAMIENTO',
  'CAT_PORCENTAJE_CARTERA',
  'CAT_SERVICIO_INVERSION',
  'CAT_GRADO_ESTUDIOS',
  'CAT_ESTRATEGIAS_INVERSION',
  'CAT_ORIGEN_RECURSOS_PERFILAMIENTO',
  'CAT_PORCENTAJE_INVERSION',
  'CAT_INGRESO_MENSUAL',
  'CAT_PREDICCIONES',
  'CAT_DEPENDIENTES',
  'CAT_OBJETIVOS_INVERSION',
  'CAT_GANANCIAS_DESTINOS',
  'CAT_PORCENTAJE_LIQUIDEZ',
  'CAT_ESTIMACION_DEVOLUCION',
  'CAT_RIESGO_GANANCIAS',
  'CAT_ESTRATEGIA_INVERSION_PORTAFOLIO',
  'CAT_PORTAFOLIO',
  'CAT_LIMITES_PORTAFOLIO',
  'CAT_TIPO_MERCADO',
  'CAT_GRUPO_TIPO_VALOR',
  'CAT_TIPO_VALOR',
  'CAT_INGRESOS_ADICIONALES',
  'CAT_TIPO_TELEFONO',
  'CAT_TIPO_MONTO_A_PROCESAR',
  'CAT_ANIOS_ANTIGUEDAD',
  'CAT_FUENTES_INGRESO',
  'CAT_PORCENTAJE_PATRIMONIO_EMPRESA',
  'CAT_TIPO_RESIDENCIA',
  'CAT_TIPO_CUENTA_INVERSION',
  'CAT_TIPO_FIRMAS',
  'CAT_RESPUESTAS_RAPIDAS',
  'CAT_TIPO_LAYOUT',
  'CAT_REGIMEN_FISCAL',
  'CAT_PERSONA_MORAL',
  'CAT_TIPO_SERVICIO',
  'CAT_ESTATUS',
  'CAT_TIPO_OPERACION',
  'CAT_RANGO_EDAD',
  'CAT_GRADO_ESTUDIO_V2',
  'CAT_OCUPACION_V2',
  'CAT_PLAZO_ANIO_ACCIONES',
  'CAT_MONTO_ACCIONES',
  'CAT_CONOCIMIENTO_CONCEPTO',
  'CAT_PORCENTAJE',
  'CAT_INGRESO_MENSUAL_V2',
  'CAT_PREDICCION_INGRESO',
  'CAT_OBJETIVO_INVERSION_V2',
  'CAT_RENDIMIENTO',
  'CAT_LIQUIDEZ',
  'CAT_PLAZO_DISPOSICION',
  'CAT_MOVIMIENTOS_PORTEX',
  'CAT_TIPO_CLIENTE',
  'CAT_DIAS_INHABILES',
  'CAT_TIPO_REPORTE',
  'CAT_INSTRUMENTO_MONETARIO',
  'CAT_LOCALIDADES',
  'CAT_MONEDA_REPORTES_INUSUALES',
];

export const catalogList: CatalogListType = {
  fileType: { keyName: 'CAT_TIPO_LAYOUT', values: [] },
  brokerageHouses: { keyName: 'CAT_CASA_BOLSA', values: [] },
  profiles: { keyName: 'CAT_PERFILES', values: [] },
  profilesModal: { keyName: 'CAT_PERFILES_MORAL', values: [] },
  nationalities: { keyName: 'CAT_NACIONALIDAD', values: [] },
  civilStatuses: { keyName: 'CAT_EDO_CIVIL', values: [] },
  resOrigins: { keyName: 'CAT_ORIGEN_RECURSOS', values: [] },
  resDestinations: { keyName: 'CAT_PROPOSITO_RECURSO', values: [] },
  professions: { keyName: 'CAT_PROFESION', values: [] },
  occupations: { keyName: 'CAT_OCUPACION', values: [] },
  companyRoles: { keyName: 'CAT_PUESTO', values: [] },
  states: { keyName: 'CAT_ENTIDAD', values: [] },
  companyAreas: { keyName: 'CAT_GIRO', values: [] },
  companySectors: { keyName: 'CAT_SECTOR', values: [] },
  economicActivities: { keyName: 'CAT_ACTIVIDAD_ECONOMICA', values: [] },
  economicActivitiesV2: {
    keyName: 'CAT_ACTIVIDAD_ECONOMICA_RIESGO',
    values: [],
  },
  frequencies: { keyName: 'CAT_PERIODICIDAD', values: [] },
  currencies: { keyName: 'CAT_MONEDA', values: [] },
  currenciesUnusualOperations: {
    keyName: 'CAT_MONEDA_REPORTES_INUSUALES',
    values: [],
  },
  relationships: { keyName: 'CAT_PARENTESCO', values: [] },
  genders: { keyName: 'CAT_GENERO', values: [] },
  houseTypes: { keyName: 'CAT_TIPO_CASA', values: [] },
  companyActivities: { keyName: 'CAT_ACTIVIDADES_EMPRESA', values: [] },
  telephoneOptions: { keyName: 'CAT_TIPO_TELEFONO', values: [] },
  amountType: { keyName: 'CAT_TIPO_MONTO_A_PROCESAR', values: [] },
  seniorityList: { keyName: 'CAT_ANIOS_ANTIGUEDAD', values: [] },
  residencyOptions: { keyName: 'CAT_TIPO_RESIDENCIA', values: [] },
  incomeSources: { keyName: 'CAT_FUENTES_INGRESO', values: [] },
  incomeLevels: { keyName: 'CAT_INGRESO_MENSUAL', values: [] },
  incomeLevelsAdditional: { keyName: 'CAT_INGRESOS_ADICIONALES', values: [] },
  shareList: { keyName: 'CAT_PORCENTAJE_PATRIMONIO_EMPRESA', values: [] },
  banks: { keyName: 'CAT_BANCOS', values: [] },
  marketType: { keyName: 'CAT_TIPO_MERCADO', values: [] },
  marketGroupType: { keyName: 'CAT_GRUPO_TIPO_VALOR', values: [] },
  marketValueType: { keyName: 'CAT_TIPO_VALOR', values: [] },
  educationLevel: { keyName: 'CAT_GRADO_ESTUDIOS', values: [] },
  knowledgeOfConcept: { keyName: 'CAT_CONOCIMIENTOS_INVERSION', values: [] },
  profilingOccupation: { keyName: 'CAT_OCUPACION_PERFILAMIENTO', values: [] },
  profilingFrequency: { keyName: 'CAT_FRECUENCIA_PERFILAMIENTO', values: [] },
  profilingDeadlines: { keyName: 'CAT_PLAZOS_PERFILAMIENTO', values: [] },
  portfolioPercentage: { keyName: 'CAT_PORCENTAJE_CARTERA', values: [] },
  investmentStrategies: { keyName: 'CAT_ESTRATEGIAS_INVERSION', values: [] },
  investmentService: { keyName: 'CAT_SERVICIO_INVERSION', values: [] },
  profilingResourcesOrigins: {
    keyName: 'CAT_ORIGEN_RECURSOS_PERFILAMIENTO',
    values: [],
  },
  investmentPercentage: { keyName: 'CAT_PORCENTAJE_INVERSION', values: [] },
  incomePrediction: { keyName: 'CAT_PREDICCIONES', values: [] },
  numberOfDependents: { keyName: 'CAT_DEPENDIENTES', values: [] },
  investmentObjectives: { keyName: 'CAT_OBJETIVOS_INVERSION', values: [] },
  destinationOfProfits: { keyName: 'CAT_GANANCIAS_DESTINOS', values: [] },
  percentageOfLiquidity: { keyName: 'CAT_PORCENTAJE_LIQUIDEZ', values: [] },
  earningsRisk: { keyName: 'CAT_RIESGO_GANANCIAS', values: [] },
  investmentAccountType: { keyName: 'CAT_TIPO_CUENTA_INVERSION', values: [] },
  bankers: { keyName: 'CAT_BANQUEROS', values: [] },
  typeOfSignatures: { keyName: 'CAT_TIPO_FIRMAS', values: [] },
  coOwnerType: {
    keyName: '_UNDEFINED_',
    values: [
      createOption({ label: 'Persona Física', value: 1 }),
      createOption({ label: 'Persona Moral', value: 2 }),
      createOption({ label: 'Fideicomiso', value: 3 }),
    ],
  },
  quickAsk: { keyName: 'CAT_RESPUESTAS_RAPIDAS', values: [] },
  taxRegime: { keyName: 'CAT_REGIMEN_FISCAL', values: [] },
  moralPersonType: { keyName: 'CAT_PERSONA_MORAL', values: [] },
  serviceType: { keyName: 'CAT_TIPO_SERVICIO', values: [] },
  accountStatus: { keyName: 'CAT_ESTATUS', values: [] },
  operationType: { keyName: 'CAT_TIPO_OPERACION', values: [] },
  ageRange: { keyName: 'CAT_RANGO_EDAD', values: [] },
  educationLevelIE: { keyName: 'CAT_GRADO_ESTUDIO_V2', values: [] },
  ocupationIE: { keyName: 'CAT_OCUPACION_V2', values: [] },
  termInStockIE: { keyName: 'CAT_PLAZO_ANIO_ACCIONES', values: [] },
  amountInStockIE: { keyName: 'CAT_MONTO_ACCIONES', values: [] },
  investmentPercentageSC: { keyName: 'CAT_PORCENTAJE', values: [] },
  investmenteLevels: { keyName: 'CAT_INGRESO_MENSUAL_V2', values: [] },
  investmentePrediction: { keyName: 'CAT_PREDICCION_INGRESO', values: [] },
  investmentObjectivesOI: { keyName: 'CAT_OBJETIVO_INVERSION_V2', values: [] },
  destinationOfProfitsOI: { keyName: 'CAT_RENDIMIENTO', values: [] },
  percentageOfLiquidityOI: { keyName: 'CAT_LIQUIDEZ', values: [] },
  profilingDeadlinesOI: { keyName: 'CAT_PLAZO_DISPOSICION', values: [] },
  movementClassifications: { keyName: 'CAT_MOVIMIENTOS_PORTEX', values: [] },
  clientTypes: { keyName: 'CAT_TIPO_CLIENTE', values: [] },
  daysInactive: { keyName: 'CAT_DIAS_INHABILES', values: [] },
  typeOfReport: { keyName: 'CAT_TIPO_REPORTE', values: [] },
  monetaryInstrument: { keyName: 'CAT_INSTRUMENTO_MONETARIO', values: [] },
  localidades: { keyName: 'CAT_LOCALIDADES', values: [] },
};

export const catalogSortByValue = [
  catalogList.ageRange.keyName,
  catalogList.termInStockIE.keyName,
  catalogList.amountInStockIE.keyName,
  catalogList.investmentPercentageSC.keyName,
  catalogList.investmenteLevels.keyName,
  catalogList.investmentePrediction.keyName,
  catalogList.investmentObjectivesOI.keyName,
  catalogList.destinationOfProfitsOI.keyName,
  catalogList.percentageOfLiquidityOI.keyName,
  catalogList.profilingDeadlinesOI.keyName,
  catalogList.numberOfDependents.keyName,
  catalogList.profiles.keyName,
  catalogList.profilesModal.keyName,
  catalogList.clientTypes.keyName,
];
